/***********
 * Minor JS tweaks/additions
 ***********/

window.addEventListener("DOMContentLoaded", () => {
  /* ReturnZap styles */

  (function () {
    const host = document.querySelector("return-zap");
    if (!host) return;

    const style = document.createElement("style");

    style.innerHTML = `
      h1 {
        font-weight: 400 !important;
        font-size: 2rem !important;
      }
      button[type="submit"] {
        text-transform: uppercase;
      }
    `;

    host.shadowRoot.appendChild(style);
  })();

  /* AccessiBe trigger */

  (function () {
    const trigger = document.getElementById("accessibeTrigger");
    if (!trigger) return;

    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      const accessibeElements = document.querySelectorAll("access-widget-ui");
      accessibeElements.forEach((el) =>
        el.shadowRoot.querySelector('[part="acsb-trigger"]')?.click()
      );
    });
  })();
});
